import { render, staticRenderFns } from "./EditUserForBuilding.vue?vue&type=template&id=40b0a5e8&"
import script from "./EditUserForBuilding.vue?vue&type=script&lang=js&"
export * from "./EditUserForBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports